module.exports = __webpack_public_path__ + "img/checkmark.8a88375a.svg";